module.exports = __webpack_public_path__ + "akne_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_3_after.jpg
// module id = 919
// module chunks = 0